module.exports = __webpack_public_path__ + "media/navigation/icon-customer-account-e197ccc2.svg";